import { ArrowDownCircle, Edit, Paperclip, Trash2 } from "lucide-react";
import { RecordFilters } from "..";

const InwardSection = ({ ctx }) => {
  const {
    exportInward,
    filteredInward,
    getMaterialName,
    handleBulkDeleteInward,
    handleDeleteInward,
    handleEditInward,
    inwardFilters,
    inwardRecords,
    inwardSummary,
    isMasterAdmin,
    materials,
    openDocUploadDialog,
    selectedInwardIds,
    setInwardFilters,
    setSelectedInwardIds,
    toggleSelectAllInward
  } = ctx;
  return (
    <>
        <div>
          {/* Bulk Delete Button */}
          {isMasterAdmin && selectedInwardIds.length > 0 && (
            <div className="mb-4 flex items-center justify-between bg-error/10 border border-error/30 rounded-sm p-3">
              <span className="text-sm font-medium text-error">
                {selectedInwardIds.length} {selectedInwardIds.length === 1 ? 'entry' : 'entries'} selected
              </span>
              <button
                onClick={handleBulkDeleteInward}
                className="btn-primary bg-error hover:bg-error/90 flex items-center space-x-2"
              >
                <Trash2 className="w-4 h-4" />
                <span>Delete Selected</span>
              </button>
            </div>
          )}
          
          <RecordFilters
            prefix="inward"
            filters={inwardFilters}
            setFilters={setInwardFilters}
            records={inwardRecords}
            materials={materials}
            partyKey="supplier_name"
            partyLabel="Supplier"
            summary={inwardSummary}
            onExport={exportInward}
          />
          <div className="stat-card overflow-x-auto">
            <table className="w-full" data-testid="inward-table">
              <thead>
                <tr className="border-b-2 border-slate-300">
                  {isMasterAdmin && (
                    <th className="py-3 px-4 w-10">
                      <input
                        type="checkbox"
                        checked={filteredInward.length > 0 && selectedInwardIds.length === filteredInward.length}
                        onChange={toggleSelectAllInward}
                        className="w-4 h-4 rounded border-slate-300 text-primary focus:ring-primary"
                        title="Select All"
                      />
                    </th>
                  )}
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">GRN No.</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Date</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Material</th>
                  <th className="text-right py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Quantity</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Supplier</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Challan</th>
                  <th className="text-center py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Bill</th>
                  <th className="text-center py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Docs</th>
                  <th className="text-center py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Status</th>
                  {isMasterAdmin && (
                    <th className="text-center py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Actions</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {filteredInward.map((record) => (
                  <tr key={record.id} className={`border-b border-slate-200 hover:bg-slate-50 ${selectedInwardIds.includes(record.id) ? 'bg-primary/5' : ''}`}>
                    {isMasterAdmin && (
                      <td className="py-3 px-4">
                        <input
                          type="checkbox"
                          checked={selectedInwardIds.includes(record.id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedInwardIds([...selectedInwardIds, record.id]);
                            } else {
                              setSelectedInwardIds(selectedInwardIds.filter(id => id !== record.id));
                            }
                          }}
                          className="w-4 h-4 rounded border-slate-300 text-primary focus:ring-primary"
                        />
                      </td>
                    )}
                    <td className="py-3 px-4 font-mono text-sm font-medium text-success">{record.grn_number}</td>
                    <td className="py-3 px-4 font-mono text-sm">{record.date}</td>
                    <td className="py-3 px-4 text-sm font-medium">{getMaterialName(record.material_id)}</td>
                    <td className="py-3 px-4 text-right font-mono text-sm font-bold text-success">+{record.quantity?.toFixed(2)}</td>
                    <td className="py-3 px-4 text-sm">{record.supplier_name}</td>
                    <td className="py-3 px-4 font-mono text-sm">{record.challan_number}</td>
                    <td className="py-3 px-4 text-center">
                      {record.bill_received ? (
                        <span className="px-2 py-1 rounded-sm text-xs font-medium bg-success/20 text-success" title={record.bill_number ? `Bill: ${record.bill_number}` : ''}>
                          ✓ Received
                        </span>
                      ) : (
                        <span className="px-2 py-1 rounded-sm text-xs font-medium bg-warning/20 text-warning">
                          Pending
                        </span>
                      )}
                    </td>
                    <td className="py-3 px-4 text-center">
                      <div className="flex items-center justify-center space-x-1">
                        {(record.documents?.length || 0) > 0 ? (
                          <button
                            onClick={() => openDocUploadDialog(record)}
                            data-testid={`doc-upload-${record.id}`}
                            className="px-2 py-1 rounded-sm text-xs font-medium bg-primary/20 text-primary hover:bg-primary/30 flex items-center space-x-1"
                            title="View/Upload Documents"
                          >
                            <Paperclip className="w-3 h-3" />
                            <span>{record.documents.length}</span>
                          </button>
                        ) : (
                          <button
                            onClick={() => openDocUploadDialog(record)}
                            data-testid={`doc-upload-${record.id}`}
                            className="p-1 hover:bg-slate-200 rounded text-slate-400 hover:text-primary"
                            title="Upload Document"
                          >
                            <Paperclip className="w-4 h-4" />
                          </button>
                        )}
                      </div>
                    </td>
                    <td className="py-3 px-4 text-center">
                      <span className={`px-2 py-1 rounded-sm text-xs font-medium ${
                        record.status === "Approved" ? "bg-success/20 text-success" : 
                        record.status === "Rejected" ? "bg-error/20 text-error" : "bg-warning/20 text-warning"
                      }`}>
                        {record.status || record.quality_status}
                      </span>
                    </td>
                    {isMasterAdmin && (
                      <td className="py-3 px-4 text-center">
                        <div className="flex items-center justify-center space-x-1">
                          <button
                            onClick={() => handleEditInward(record)}
                            data-testid={`edit-inward-${record.id}`}
                            className="p-1 hover:bg-slate-200 rounded"
                            title="Edit Inward Entry"
                          >
                            <Edit className="w-4 h-4 text-primary" />
                          </button>
                          <button
                            onClick={() => handleDeleteInward(record.id, record.grn_number)}
                            data-testid={`delete-inward-${record.id}`}
                            className="p-1 hover:bg-red-100 rounded"
                            title="Delete Inward Entry"
                          >
                            <Trash2 className="w-4 h-4 text-error" />
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            {filteredInward.length === 0 && (
              <div className="text-center py-12 text-slate-500" data-testid="inward-empty">
                <ArrowDownCircle className="w-16 h-16 mx-auto mb-4 text-slate-400" />
                {inwardRecords.length === 0 ? "No inward records yet." : "No inward records match the filters."}
              </div>
            )}
          </div>
        </div>
    </>
  );
};

export default InwardSection;
